export type Certificate = {
	certificate_id: string;
	name: string;
	type:
	| 'natural'
	| 'legal_representative'
	| 'company';
	status: 'Active' | 'Inactive' | 'Pending';
	expiry_date: string;
	activation_ulid: string;
	expiration_ulid: string;
	revocation_ulid: string;
	suspension_ulid: string;
	status_description: 'reactivated' | 'suspended' | 'revoked';
};

export function isCertificate(
	certificate: unknown,
): certificate is Certificate {
	if (typeof certificate !== 'object' || certificate === null) {
		return false;
	}

	const cert = certificate as Record<string, unknown>;

	// Valid certificate types
	const validTypes = [
		'natural',
		'legal_representative',
		'professional',
		'employee',
		'company',
		'public_official',
		'userCertV1', //TODO: check this
	];

	// Valid statuses
	const validStatuses = ['Active', 'Inactive', 'Pending'];

	// Valid status descriptions
	const validStatusDescriptions = ['reactivated', 'suspended', 'revoked', ''];

	return true;

	return (
		typeof cert.certificate_id === 'string' &&
		typeof cert.name === 'string' &&
		typeof cert.type === 'string' &&
		// validTypes.includes(cert.type) && //TODO: revert this
		typeof cert.status === 'string' &&
		validStatuses.includes(cert.status) &&
		typeof cert.expiry_date === 'string' &&
		typeof cert.activation_ulid === 'string' &&
		typeof cert.expiration_ulid === 'string' &&
		typeof cert.revocation_ulid === 'string' &&
		typeof cert.suspension_ulid === 'string' &&
		typeof cert.status_description === 'string' &&
		validStatusDescriptions.includes(cert.status_description)
	);
}

//

/** Spanish labels for the certificate types chosen in onboarding. */
export const CERTIFICATE_TYPE_LABELS: Record<string, string> = {
	natural: 'Persona individual',
	legal_representative: 'Representante legal',
	company: 'Persona jurídica',
	employee: 'Empleado de persona jurídica',
	professional: 'Profesional colegiado',
	public_official: 'Funcionario público',
};
